import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Email আর Password দাও');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (e) {
      setError('Email বা Password ভুল!');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>🎮</div>
        <h1 style={styles.title}>FF Arena Admin</h1>
        <p style={styles.subtitle}>Admin Panel</p>

        {error && <div style={styles.error}>{error}</div>}

        <input
          style={styles.input}
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleLogin()}
        />
        <button
          style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Login হচ্ছে...' : '🔐 Login করো'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', background: '#0a0a1a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  card: {
    background: '#111128', borderRadius: 20,
    padding: 40, width: 380,
    border: '1px solid #f4c43033',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
  },
  logo: { fontSize: 56, marginBottom: 12 },
  title: { color: '#fff', fontSize: 24, fontWeight: 'bold', margin: 0 },
  subtitle: { color: '#888', fontSize: 14, marginBottom: 32, marginTop: 6 },
  error: {
    background: '#ff444422', border: '1px solid #ff444444',
    color: '#ff6b6b', borderRadius: 10, padding: '10px 16px',
    marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 14,
  },
  input: {
    width: '100%', background: '#0a0a1a',
    border: '1px solid #333', borderRadius: 10,
    color: '#fff', fontSize: 15,
    padding: '12px 16px', marginBottom: 12,
    outline: 'none', boxSizing: 'border-box',
  },
  button: {
    width: '100%', background: '#f4c430',
    border: 'none', borderRadius: 10,
    color: '#000', fontSize: 16, fontWeight: 'bold',
    padding: '14px', cursor: 'pointer', marginTop: 8,
  },
};